import React, { useEffect, useState } from "react";
import AboutHeader from "../../components/aboutHeader/aboutHeader";
import { firestore } from "../../db/config";
import BitAddressForm from "./copyBitcoinAddress";
import PayPalButtonFunction from "./payPalButton";
var QRCode = require("qrcode.react");
export default function ChoosePaymentType({ inestmentAmount }) {
  const [paymentOptionSelect, setpaymentOptionSelect] = useState({
    name: "",
    status: false,
  });
  const handleRadioButtonChange = (status, name) => {
    setpaymentOptionSelect({
      name,
      status,
    });
  };
  console.log(paymentOptionSelect.name);
  const [amount, setamount] = useState("");
  const handleAmountChange = (value, attr) => {
    setamount(value);
  };
  const [bitCoinAddress, setbitCoinAddress] = useState("");
  useEffect(() => {
    firestore
      .collection("paymentMethod")
      .get()
      .then((data) => {
        const bitCoinAddress = data.docs.find(
          (payment) => payment.data().paymentName === "bitcoin"
        );
        setbitCoinAddress(bitCoinAddress.data().paymentAddress);
      });
  }, []);
  return (
    <div>
      <div class="payment_mode_wrapper float_left">
        <div class="row">
          <div class="col-md-12 col-lg-12 col-sm-12 col-12">
            <div class="sv_heading_wraper">
              <h3>choose payment mode</h3>
            </div>
          </div>
          <div class="col-md-12 col-lg-12 col-sm-12 col-12">
            <div class="payment_radio_btn_wrapper float_left">
              <div class="radio">
                <input
                  type="radio"
                  name="ratio"
                  id="poa"
                  checked={paymentOptionSelect.name === "payPal" ? true : false}
                  onChange={(evt) =>
                    handleRadioButtonChange(evt.target.checked, "payPal")
                  }
                />
                <label for="poa">
                  <img
                    src="images/partner1.png"
                    alt="img"
                    style={{ width: "100px", objectFit: "contain" }}
                  />
                </label>
              </div>
              {/* <div class="radio">
                <input
                  type="radio"
                  name="ratio"
                  id="job"
                  checked={
                    paymentOptionSelect.name === "cashDeposit" ? true : false
                  }
                  onChange={(evt) =>
                    handleRadioButtonChange(evt.target.checked, "cashDeposit")
                  }
                />
                <label for="job">
                  <img
                    src="images/cash-deposit.png"
                    alt="img"
                    style={{ width: "100px", objectFit: "contain" }}
                  />
                </label>
              </div> */}
              <div class="radio">
                <input
                  type="radio"
                  name="ratio"
                  id="bit"
                  checked={
                    paymentOptionSelect.name === "bitCoin" ? true : false
                  }
                  onChange={(evt) =>
                    handleRadioButtonChange(evt.target.checked, "bitCoin")
                  }
                />
                <label for="bit">
                  <img
                    src="images/bit-coin.png"
                    alt="img"
                    style={{ width: "100px", objectFit: "contain" }}
                  />
                </label>
              </div>
              <div class="radio">
                <input
                  type="radio"
                  name="ratio"
                  id="cashApp"
                  checked={
                    paymentOptionSelect.name === "transfer" ? true : false
                  }
                  onChange={(evt) =>
                    handleRadioButtonChange(evt.target.checked, "transfer")
                  }
                />
                <label for="cashApp">
                  <img
                    src="images/money (1).png"
                    alt="img"
                    style={{ width: "60px", objectFit: "contain" }}
                  />
                </label>
              </div>
              <div class="radio">
                <input
                  type="radio"
                  name="ratio"
                  id="check"
                  checked={
                    paymentOptionSelect.name === "wireTransfer" ? true : false
                  }
                  onChange={(evt) =>
                    handleRadioButtonChange(evt.target.checked, "wireTransfer")
                  }
                />
                <label for="check">
                  <img
                    src="images/exchange.png"
                    alt="img"
                    style={{ width: "60px", objectFit: "contain" }}
                  />
                  Wire Transfer
                </label>
              </div>
              {/* <div class="about_btn acc_balance_btn float_left">
                <p>YOUR ACCOUNT BALANCE :</p>
                <ul>
                  <li>
                    <a className="handle__updates__button">$ 498.61</a>
                  </li>
                </ul>
              </div> */}
              <div class="about_btn float_left">
                {paymentOptionSelect.name === "payPal" ? (
                  <div
                    style={{
                      width: "100%",
                      paddingTop: "20px",
                      paddingBottom: "20px",
                      background: "#E88A00",
                      color: "white",
                      fontWeight: "700",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                      borderRadius: "6px",
                    }}
                  >
                    Payment via paypal will be available soon.
                  </div>
                ) : (
                  // <div>
                  //   <div class="change_field">
                  //     <label>Enter amount to invest :</label>
                  //     <input
                  //       type="number"
                  //       placeholder="Enter amount"
                  //       // value={}
                  //       onChange={(evt) =>
                  //         handleAmountChange(evt.target.value, "amount")
                  //       }
                  //     />
                  //   </div>
                  //   {amount ? (
                  //     <PayPalButtonFunction
                  //       investmentPlan={{ ...inestmentAmount }}
                  //       amount={amount}
                  //     />
                  //   ) : (
                  //     ""
                  //   )}
                  // </div>
                  ""
                )}

                {/* <ul>
                  <li>
                    <a href="#">submit</a>
                  </li>
                </ul> */}
                {paymentOptionSelect.name === "bitCoin" ? (
                  <div>
                    {/* <div style={{ marginBottom: "20px" }}>
                      <QRCode value={bitCoinAddress ? bitCoinAddress : ""} />
                    </div>
                    <BitAddressForm bitCoinAddress={bitCoinAddress} /> */}
                  </div>
                ) : (
                  ""
                )}
                {paymentOptionSelect.name === "transfer" ? (
                  <div>
                    <p
                      style={{
                        marginBottom: "30px",
                        fontWeight: "700",
                        color: "black",
                        fontSize: "20px",
                      }}
                    >
                      Make payment to this account details.
                    </p>
                    {/* first account card */}
                    {/* <div class="card"> */}
                    {/* <div class="card-body">
                        <p>
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            Bank Name:
                          </strong>{" "}
                          Regions Bank
                        </p>{" "}
                        <br />
                        <p>
                          {" "}
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            {" "}
                            Account Name
                          </strong>
                          : Digital Bridges LLC{" "}
                        </p>
                        <br />
                        <p>
                          {" "}
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            {" "}
                            Account Number
                          </strong>
                          : 0302350440{" "}
                        </p>
                        <br />
                        <p>
                          {" "}
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            {" "}
                            Address
                          </strong>
                          : 11900 BISCAYNE BLVD NORTH MIAMI, FL 33181{" "}
                        </p>
                        <br />
                        <strong style={{ fontWeight: 700, color: "black" }}>
                          Swift
                        </strong>{" "}
                        UPNBUS44
                        <p>
                          <div
                            style={{
                              paddingTop: "20px",
                              paddingBottom: "20px",
                              paddingLeft: "20px",
                              paddingRight: "20px",
                              background: "#FFF3CD",
                              color: "black",
                              fontWeight: "700",
                              marginTop: "20px",
                              borderRadius: "6px",
                            }}
                          >
                            All payment receipts and confirmations should be
                            sent to support@treasuregrowth.com
                          </div>
                        </p>
                      </div>
                    </div> */}
                    {/* second account details */}
                    <div class="card" style={{ marginTop: "20px" }}>
                      <div class="card-body">
                        {/* <p>
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            Bank Name:
                          </strong>{" "}
                          Indian Overseas Bank 3rd floor, Ruttonjee House 11
                          Duddell Street, Hong Kong
                        </p>{" "} */}
                        <p>
                          {" "}
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            Bank name{" "}
                          </strong>
                          : Wellsfargo
                        </p>
                        <br />
                        <p>
                          {" "}
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            {" "}
                            Account Number
                          </strong>
                          2100012545396
                        </p>
                        <br />
                        {/* <p>
                          {" "}
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            {" "}
                            Account Number
                          </strong>
                          : 050102000000696{" "}
                        </p> */}
                        <p>
                          {" "}
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            Account Name
                          </strong>{" "}
                          :Conair corporation
                        </p>
                        <br />
                        <p>
                          {" "}
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            Address
                          </strong>{" "}
                          :420 montgomery San Fransisco , CA 94104
                        </p>
                        <br />
                        {/* <p>
                          {" "}
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            {" "}
                            Address
                          </strong>
                          : TransferWise 56 Shoreditch High Street London E1 UK */}
                        {/* Ph: 31592400,
                          fax 39057992 */}
                        {/* </p>
                        <br /> */}
                        <strong style={{ fontWeight: 700, color: "black" }}>
                          Swift
                        </strong>{" "}
                        WFBIUS6S
                        <hr></hr>
                        <p>
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            ROUTING
                          </strong>{" "}
                          : 121000248
                        </p>
                        <br />
                        {/* <p>
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            BENEFICIARY:
                          </strong>{" "}
                          Conair Corporation
                        </p>
                        <br /> */}
                        {/* <p>
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            ABA ROUTING
                          </strong>{" "}
                          : 121000248
                        </p>
                        <br /> */}
                        {/* <p>
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            SWIFT ID:
                          </strong>{" "}
                          WFBIUS6S
                        </p>
                        <br /> */}
                        {/* <p>
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            CHIPS:
                          </strong>{" "}
                          0407
                        </p> */}

                        <p>
                          <div
                            style={{
                              paddingTop: "20px",
                              paddingBottom: "20px",
                              paddingLeft: "20px",
                              paddingRight: "20px",
                              background: "#FFF3CD",
                              color: "black",
                              fontWeight: "700",
                              marginTop: "20px",
                              borderRadius: "6px",
                            }}
                          >
                            Please Note:All payment must be in US Dollars
                            <br></br>
                            All payment receipts and confirmations should be
                            sent to support@treasuregrowth.com
                          </div>
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {paymentOptionSelect.name === "bitCoin" ? (
                  <div>
                    <div style={{ marginBottom: "20px" }}>
                      <QRCode value={bitCoinAddress ? bitCoinAddress : ""} />
                    </div>
                    <BitAddressForm bitCoinAddress={bitCoinAddress} />
                    <p style={{ marginTop: "70px" }}>
                      <div
                        style={{
                          paddingTop: "20px",
                          paddingBottom: "20px",
                          paddingLeft: "20px",
                          paddingRight: "20px",
                          background: "#FFF3CD",
                          color: "black",
                          fontWeight: "700",
                          marginTop: "20px",
                          borderRadius: "6px",
                        }}
                      >
                        All payment receipts and confirmations should be sent to
                        support@treasuregrowth.com
                      </div>
                    </p>
                  </div>
                ) : (
                  ""
                )}
                {paymentOptionSelect.name === "wireTransfer" ? (
                  <div>
                  <p
                    style={{
                      marginBottom: "30px",
                      fontWeight: "700",
                      color: "black",
                      fontSize: "20px",
                    }}
                  >
                    Make payment to this account details.
                  </p>
                  {/* first account card */}
                  {/* <div class="card"> */}
                  {/* <div class="card-body">
                      <p>
                        <strong style={{ fontWeight: 700, color: "black" }}>
                          Bank Name:
                        </strong>{" "}
                        Regions Bank
                      </p>{" "}
                      <br />
                      <p>
                        {" "}
                        <strong style={{ fontWeight: 700, color: "black" }}>
                          {" "}
                          Account Name
                        </strong>
                        : Digital Bridges LLC{" "}
                      </p>
                      <br />
                      <p>
                        {" "}
                        <strong style={{ fontWeight: 700, color: "black" }}>
                          {" "}
                          Account Number
                        </strong>
                        : 0302350440{" "}
                      </p>
                      <br />
                      <p>
                        {" "}
                        <strong style={{ fontWeight: 700, color: "black" }}>
                          {" "}
                          Address
                        </strong>
                        : 11900 BISCAYNE BLVD NORTH MIAMI, FL 33181{" "}
                      </p>
                      <br />
                      <strong style={{ fontWeight: 700, color: "black" }}>
                        Swift
                      </strong>{" "}
                      UPNBUS44
                      <p>
                        <div
                          style={{
                            paddingTop: "20px",
                            paddingBottom: "20px",
                            paddingLeft: "20px",
                            paddingRight: "20px",
                            background: "#FFF3CD",
                            color: "black",
                            fontWeight: "700",
                            marginTop: "20px",
                            borderRadius: "6px",
                          }}
                        >
                          All payment receipts and confirmations should be
                          sent to support@treasuregrowth.com
                        </div>
                      </p>
                    </div>
                  </div> */}
                  {/* second account details */}
                  <div class="card" style={{ marginTop: "20px" }}>
                      <div class="card-body">
                        {/* <p>
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            Bank Name:
                          </strong>{" "}
                          Indian Overseas Bank 3rd floor, Ruttonjee House 11
                          Duddell Street, Hong Kong
                        </p>{" "} */}
                        <p>
                          {" "}
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            Bank name{" "}
                          </strong>
                          : Wellsfargo
                        </p>
                        <br />
                        <p>
                          {" "}
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            {" "}
                            Account Number
                          </strong>
                          2100012545396
                        </p>
                        <br />
                        {/* <p>
                          {" "}
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            {" "}
                            Account Number
                          </strong>
                          : 050102000000696{" "}
                        </p> */}
                        <p>
                          {" "}
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            Account Name
                          </strong>{" "}
                          :Conair corporation
                        </p>
                        <br />
                        <p>
                          {" "}
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            Address
                          </strong>{" "}
                          :420 montgomery San Fransisco , CA 94104
                        </p>
                        <br />
                        {/* <p>
                          {" "}
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            {" "}
                            Address
                          </strong>
                          : TransferWise 56 Shoreditch High Street London E1 UK */}
                        {/* Ph: 31592400,
                          fax 39057992 */}
                        {/* </p>
                        <br /> */}
                        <strong style={{ fontWeight: 700, color: "black" }}>
                          Swift
                        </strong>{" "}
                        WFBIUS6S
                        <hr></hr>
                        <p>
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            ROUTING
                          </strong>{" "}
                          : 121000248
                        </p>
                        <br />
                        {/* <p>
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            BENEFICIARY:
                          </strong>{" "}
                          Conair Corporation
                        </p>
                        <br /> */}
                        {/* <p>
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            ABA ROUTING
                          </strong>{" "}
                          : 121000248
                        </p>
                        <br /> */}
                        {/* <p>
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            SWIFT ID:
                          </strong>{" "}
                          WFBIUS6S
                        </p>
                        <br /> */}
                        {/* <p>
                          <strong style={{ fontWeight: 700, color: "black" }}>
                            CHIPS:
                          </strong>{" "}
                          0407
                        </p> */}

                        <p>
                          <div
                            style={{
                              paddingTop: "20px",
                              paddingBottom: "20px",
                              paddingLeft: "20px",
                              paddingRight: "20px",
                              background: "#FFF3CD",
                              color: "black",
                              fontWeight: "700",
                              marginTop: "20px",
                              borderRadius: "6px",
                            }}
                          >
                            Please Note:All payment must be in US Dollars
                            <br></br>
                            All payment receipts and confirmations should be
                            sent to support@treasuregrowth.com
                          </div>
                        </p>
                      </div>
                    </div>
                </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
